class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.clearBtn = this.querySelector('.search-overlay__clear');

    this.input.addEventListener(
      'input',
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    // Show/hide clear button on input
    this.input.addEventListener('input', () => this.toggleClearBtn());

    // Clear input on click
    if (this.clearBtn) {
      this.clearBtn.addEventListener('click', () => {
        this.input.value = '';
        this.toggleClearBtn();
        this.input.focus();
        this.onChange();
      });
    }

    // Clear input when cancel/close is clicked
    const cancelBtn = this.querySelector('.search-overlay__cancel');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', () => {
        this.input.value = '';
        this.toggleClearBtn();
        this.onChange();
      });
    }

    const togglePredictiveSearchClass = (isFocused) => {
      document.body.classList.toggle('open-predictive', isFocused);
      document.body.classList.toggle('no-scroll', isFocused);
    };

    this.input.addEventListener('focus', () =>
      togglePredictiveSearchClass(true)
    );
    // this.input.addEventListener('blur', () =>
    //   togglePredictiveSearchClass(false)
    // );

    // Close overlay and clear input on form submit (Enter key)
    const form = this.querySelector('form');
    if (form) {
      form.addEventListener('submit', () => {
        this.close();
      });
    }

    // Close overlay and clear input on "View all results" click
    this.predictiveSearchResults.addEventListener('click', (e) => {
      const viewAllBtn = e.target.closest('.view-search-results-btn');
      if (viewAllBtn) {
        this.close();
      }
    });

    this.toggleClearBtn();
    this.onChange();
  }

  close() {
    this.input.value = '';
    this.toggleClearBtn();
    document.body.classList.remove('open-predictive', 'no-scroll');
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    const url = searchTerm.length
      ? `/search/suggest?q=${searchTerm}&resources[type]=query,product,collection&resources[limit]=10&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,vendor&section_id=predictive-search`
      : '/?section_id=predictive-search-default';
    const template = searchTerm.length ? '' : '-default';

    this.getSearchResults(url, template);
  }

  getSearchResults(url, template) {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector(
            `#shopify-section-predictive-search${template}`
          ).innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;

        // Add href to view all results button
        if (document.querySelector('.view-search-results-btn')) {
          document
            .querySelector('.view-search-results-btn')
            .setAttribute(
              'href',
              `/search?q=${this.input.value.trim().replace(' ', '+')}`
            );
        }
      })
      .catch((error) => {
        throw error;
      });
  }

  toggleClearBtn() {
    if (this.clearBtn) {
      this.clearBtn.style.display = this.input.value.trim().length ? 'flex' : 'none';
    }
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);

// class PredictiveSearch extends HTMLElement {
//   constructor() {
//     super();

//     this.input = this.querySelector('input[type="search"]');
//     this.predictiveSearchResults = this.querySelector('#predictive-search');

//     this.input.addEventListener('focus', this.open.bind(this));

//     this.input.addEventListener(
//       'input',
//       this.debounce((event) => {
//         this.onChange(event);
//       }, 300).bind(this)
//     );

//     this.onChange();
//   }

//   onChange() {
//     const searchTerm = this.input.value.trim();
//     const url = searchTerm.length
//       ? `/search/suggest?q=${searchTerm}&section_id=predictive-search`
//       : '/?section_id=predictive-search-default';
//     const template = searchTerm.length ? '' : '-default';

//     this.getSearchResults(url, template);
//   }

//   getSearchResults(url, template) {
//     fetch(url)
//       .then((response) => {
//         if (!response.ok) {
//           var error = new Error(response.status);
//           this.close();
//           throw error;
//         }

//         return response.text();
//       })
//       .then((text) => {
//         const resultsMarkup = new DOMParser()
//           .parseFromString(text, 'text/html')
//           .querySelector(
//             `#shopify-section-predictive-search${template}`
//           ).innerHTML;
//         this.predictiveSearchResults.innerHTML = resultsMarkup;

//         // Add href to view all results button
//         if (document.querySelector('.view-search-results-btn')) {
//           document
//             .querySelector('.view-search-results-btn')
//             .setAttribute(
//               'href',
//               `/search?q=${this.input.value.trim().replace(' ', '+')}`
//             );
//         }

//         // this.open();
//       })
//       .catch((error) => {
//         this.close();
//         throw error;
//       });
//   }

//   open() {
//     this.predictiveSearchResults.style.display = 'block';
//   }

//   close() {
//     this.predictiveSearchResults.style.display = 'none';
//   }

//   debounce(fn, wait) {
//     let t;
//     return (...args) => {
//       clearTimeout(t);
//       t = setTimeout(() => fn.apply(this, args), wait);
//     };
//   }
// }

// customElements.define('predictive-search', PredictiveSearch);
